import { useAppContext } from 'Main';
import React from 'react';
import { Col, Placeholder, Row } from 'react-bootstrap';

const MainPlaceholder = () => {
  const {
    config: { isFluid }
  } = useAppContext();

  return (
    <div
      className={isFluid ? 'container-fluid' : 'container'}
      style={{ height: '100vh' }}
    >
      <Placeholder as="div" animation="glow">
        <Placeholder xs={12} style={{ height: '40px', marginTop: '10px' }} />
      </Placeholder>
      <Row className="h-100">
        <Col lg={3}>
          <Placeholder as="div" animation="glow" className="h-100">
            <Placeholder xs={12} style={{ height: '80%', marginTop: '10px' }} />
          </Placeholder>
        </Col>
        <Col lg={9}>
          <Placeholder as="div" animation="glow" className="h-100">
            <Placeholder xs={12} style={{ height: '30%', marginTop: '10px' }} />
            <Placeholder xs={12} style={{ height: '30%', marginTop: '10px' }} />
            <Placeholder xs={12} style={{ height: '20%', marginTop: '10px' }} />
          </Placeholder>
        </Col>
      </Row>
    </div>
  );
};

export default MainPlaceholder;
